import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useI18n } from "@/i18n";
import { useAuth } from "@/context/AuthContext";
import { AirplaneTilt, CircleNotch, ArrowLeft } from "@phosphor-icons/react";

const BG = "https://images.pexels.com/photos/7594130/pexels-photo-7594130.jpeg?auto=compress&cs=tinysrgb&w=1200";

export default function AdminLogin() {
  const { t } = useI18n();
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("dispatcher@flughafentaxi-zrh.ch");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try { await login(email, password); nav("/admin"); }
    catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Login failed");
    } finally { setLoading(false); }
  };

  const inputCls = "w-full bg-white border border-[#E9E5DE] rounded-2xl px-4 py-3.5 font-body text-sm focus:border-[#EF5A1E] focus:ring-1 focus:ring-[#EF5A1E] focus:outline-none";

  return (
    <div className="min-h-screen grid lg:grid-cols-2" data-testid="admin-login-page">
      {/* Left visual */}
      <div className="relative hidden lg:block bg-[#0A0A0A]">
        <img src={BG} alt="" className="w-full h-full object-cover opacity-70" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-black/20 grain" />
        <div className="absolute top-8 left-8 flex items-center gap-2.5">
          <div className="w-9 h-9 bg-white flex items-center justify-center"><AirplaneTilt size={20} weight="fill" color="#0A0A0A" /></div>
          <span className="font-heading font-semibold tracking-tight text-lg text-white">{t("brand")}</span>
        </div>
        <div className="absolute bottom-12 left-8 right-8">
          <p className="font-body text-xs uppercase tracking-[0.24em] text-white/50 mb-4">Dispatch Control</p>
          <h2 className="font-heading font-light tracking-tighter text-4xl text-white leading-tight">{t("dashboard")}</h2>
        </div>
      </div>

      {/* Right form */}
      <div className="flex items-center justify-center px-6 py-16 bg-white">
        <div className="w-full max-w-sm">
          <Link to="/" className="inline-flex items-center gap-2 font-body text-xs uppercase tracking-widest text-[#52525B] hover:text-[#0A0A0A] transition-colors duration-200 mb-10">
            <ArrowLeft size={14} /> {t("brand")}
          </Link>
          <p className="font-body text-xs uppercase tracking-[0.24em] text-[#EF5A1E] mb-3">{t("nav_admin")}</p>
          <h1 className="font-heading font-light tracking-tighter text-4xl">{t("admin_login")}</h1>
          <form onSubmit={submit} className="mt-8 space-y-5">
            <div>
              <label className="font-body text-[10px] uppercase tracking-[0.16em] text-[#52525B] mb-1.5 block">{t("email")}</label>
              <input data-testid="admin-email" type="email" className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <div>
              <label className="font-body text-[10px] uppercase tracking-[0.16em] text-[#52525B] mb-1.5 block">Password</label>
              <input data-testid="admin-password" type="password" className={inputCls} value={password} onChange={(e) => setPassword(e.target.value)} />
            </div>
            {error && <p className="font-body text-sm text-[#EF4444]" data-testid="admin-login-error">{error}</p>}
            <button data-testid="admin-login-btn" disabled={loading} className="w-full flex items-center justify-center gap-2 bg-[#EF5A1E] text-white font-body font-medium text-sm uppercase tracking-[0.15em] py-4 hover:bg-[#D2450F] transition-colors duration-300 disabled:opacity-60">
              {loading && <CircleNotch size={16} className="animate-spin" />} {t("login")}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

